import { lazy } from "react";
import PageSEO from "@/components/PageSEO";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import MarketRatesSection from "@/components/MarketRatesSection";
import DeferredSection from "@/components/DeferredSection";

// Below-the-fold sections load on approach, keeping the initial bundle small.
const ChoosePathSection = lazy(() => import("@/components/ChoosePathSection"));
const PhilosophySection = lazy(() => import("@/components/PhilosophySection"));
const AffordabilitySection = lazy(() => import("@/components/AffordabilitySection"));
const LoanProgramsPreview = lazy(() => import("@/components/LoanProgramsPreview"));
const ProcessSection = lazy(() => import("@/components/ProcessSection"));
const ResourcesPreview = lazy(() => import("@/components/ResourcesPreview"));
const ReviewsSection = lazy(() => import("@/components/ReviewsSection"));
const CTASection = lazy(() => import("@/components/CTASection"));
const JourneyBar = lazy(() => import("@/components/JourneyBar"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
  <>
    <PageSEO
      title="Hiler Mortgage | Minnesota Home Loans & Refinancing"
      description="Hiler Mortgage in Champlin, MN offers expert mortgage guidance — home purchase loans, refinancing, FHA, VA, USDA, jumbo, and more. NMLS #2817074."
      path="/"
    />

    <Header />
    <main id="main-content">
      <HeroSection />
      <MarketRatesSection />

      <DeferredSection minHeight={620}>
        <ChoosePathSection />
      </DeferredSection>

      <div className="divider-subtle mx-auto max-w-6xl" />

      <DeferredSection minHeight={220}>
        <JourneyBar />
      </DeferredSection>

      <DeferredSection id="step-payment" minHeight={620}>
        <PhilosophySection />
      </DeferredSection>

      <div className="divider-subtle mx-auto max-w-6xl" />

      <DeferredSection id="step-affordability" minHeight={620}>
        <AffordabilitySection />
      </DeferredSection>

      <DeferredSection id="step-loans" minHeight={700}>
        <LoanProgramsPreview />
      </DeferredSection>

      <DeferredSection id="step-preapproval" minHeight={620}>
        <ProcessSection />
      </DeferredSection>

      <DeferredSection minHeight={620}>
        <ResourcesPreview />
      </DeferredSection>

      <DeferredSection minHeight={620}>
        <ReviewsSection />
      </DeferredSection>

      <DeferredSection minHeight={420}>
        <CTASection />
      </DeferredSection>
    </main>

    <DeferredSection minHeight={520}>
      <Footer />
    </DeferredSection>
  </>
  );
};

export default Index;
